import * as React from 'react';
import { ReactComponent as WarningIcon } from 'assets/icons/warning.svg';

import { Message } from './Message';

interface Props {
  onRetry: () => void;
  originStage: 'uploading' | 'assignment';
  message?: string;
}

export const Error: React.FC<Props> = ({ onRetry = () => {}, originStage, message }) => {
  let content: React.ReactNode = null;

  switch (originStage) {
    case 'uploading':
      content = (
        <div className="space-y-4">
          <div className="text-2xl">There was an error with your upload</div>
          {message && <p>{message}</p>}
          <p>
            Please{' '}
            <span onClick={onRetry} className="underline text-blue-900 cursor-pointer">
              try again
            </span>{' '}
            with a different file format.
          </p>
        </div>
      );
      break;
    case 'assignment':
      content = <div className="text-2xl mb-4">There was an error assigning your customers</div>;
      break;
    default:
      break;
  }

  return (
    <Message>
      <div className="flex justify-center">
        <WarningIcon />
      </div>
      {content}
    </Message>
  );
};
Error.displayName = 'Error';
